import { useStyletron } from "baseui";
import { ModalButton } from "baseui/modal"
import { useState } from "react";
import { IAutomationObject } from "../../automationObjects";
import { useCloneObjectMutation } from "../../services/objects";
import { FormattedMessage, useIntl } from 'react-intl';
import { ModalAutoSize } from "../../components/ModalAutoSize";
import { useReportMutationState } from "../../hooks/useReportMutationState";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Checkbox } from "baseui/checkbox";
import { VerticalStackPanel } from "../../components/Layout/StackPanel";
import { ListItem, ListItemLabel } from "baseui/list";
import { Spinner } from "baseui/icon";

const CloneAppDialog = (props: { isOpen: boolean, setIsOpen: any, appToClone: IAutomationObject }) => {

    const { isOpen, setIsOpen, appToClone } = props;
    const [state, setState] = useState({ newName: appToClone.name + " 1", newDescription: appToClone.description, recursive: true, includeProperties: false })
    const [clone, cloneResult] = useCloneObjectMutation();
    useReportMutationState(cloneResult,() => setIsOpen(false), { message:  'Successfully cloned' }); 
    const intl = useIntl();

    const handleClone = () => {
        clone({
            id: appToClone.id,
            resourceGroupId: appToClone.resourceGroupId,
            newDescription: state.newDescription,
            newName: state.newName,
            includeProperties: state.includeProperties,
            recursive: state.recursive
        });
    }

    const handleNameChanged = (e: any) => {
        setState((prev) => ({
            ...prev,
            newName: e.target.value
        }))
    }
    const handleDescriptionChanged = (e: any) => {
        setState((prev) => ({
            ...prev,
            newDescription: e.target.value
        }))
    }
    const handleRecursiveChanged = (e: any) => {
        setState((prev) => ({
            ...prev,
            recursive: e.target.checked
        }))
    }
    const handleClonePropertiesChanged = (e: any) => {
        setState((prev) => ({
            ...prev,
            includeProperties: e.target.checked
        }))
    }
    return (
        <>
            {(appToClone && isOpen) &&
                < ModalAutoSize isOpen={isOpen} setIsOpen={setIsOpen}
                    header={<FormattedMessage id="CloneAppDialog.Title" defaultMessage="Clone App"></FormattedMessage>}
                    body={
                        <VerticalStackPanel>
                            <ListItem key={appToClone.id}>
                                <ListItemLabel description={appToClone.name}>
                                    {appToClone.description}
                                </ListItemLabel>
                            </ListItem>
                            <FormControl
                                label={() => intl.formatMessage({ id: "CloneAppDialog.NewName", defaultMessage: "Name for new App" })}
                                caption={() => intl.formatMessage({ id: "CloneAppDialog.EnterName", defaultMessage: "Enter new name" })}
                            >
                                <Input autoFocus value={state.newName} onChange={handleNameChanged} placeholder={intl.formatMessage({ id: "CloneAppDialog.EnterName", defaultMessage: "Enter new name" })} />
                            </FormControl>
                            <FormControl
                                label={() => intl.formatMessage({ id: "CloneAppDialog.NewDescription", defaultMessage: "Description for new App" })}
                                caption={() => intl.formatMessage({ id: "CloneAppDialog.EnterDescription", defaultMessage: "Enter new description" })}
                            >
                                <Input value={state.newDescription} onChange={handleDescriptionChanged} placeholder={intl.formatMessage({ id: "CloneAppDialog.EnterDescription", defaultMessage: "Enter new description" })} />
                            </FormControl>
                            <FormControl
                                label={() => intl.formatMessage({ id: "CloneAppDialog.Settings", defaultMessage: "Settings" })}
                                caption={() => intl.formatMessage({ id: "CloneAppDialog.SettingsDescr", defaultMessage: "Additional settings" })}
                            >
                                <VerticalStackPanel>
                                    <Checkbox labelPlacement="right" checked={state.recursive} checkmarkType={'toggle'} onChange={handleRecursiveChanged}                        >
                                        {intl.formatMessage({ id: "CloneAppDialog.Recursive", defaultMessage: "Recursive" })}
                                    </Checkbox>
                                    <Checkbox labelPlacement="right" checked={state.includeProperties} checkmarkType={'toggle'} onChange={handleClonePropertiesChanged}                        >
                                    {intl.formatMessage({ id: "CloneAppDialog.CloneProperties", defaultMessage: "Clone Properties" })}
                                    </Checkbox>
                                </VerticalStackPanel>
                            </FormControl>
                        </VerticalStackPanel>
                    }
                    footer={<>
                        <ModalButton size='compact' kind={'tertiary'} onClick={() => setIsOpen(false)}><FormattedMessage id="cancel" defaultMessage="Cancel"></FormattedMessage> </ModalButton>
                        <ModalButton size='compact' disabled={cloneResult.isLoading} onClick={handleClone}>
                            {cloneResult.isLoading && <Spinner></Spinner>}
                            <FormattedMessage id="CloneAppDialog.Clone" defaultMessage="Clone"></FormattedMessage></ModalButton>
                    </>}
                ></ModalAutoSize >
            }
        </>
    );

}


export default CloneAppDialog;
